import {UmpireArticle} from '../umpire-article';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component/umpire-component';
import {ItemSelectionType} from '../umpire-component-hero-generic';

export interface UmpireComponentMainHeroArticles
  extends UmpireComponent<UmpireComponentTypeEnum.HERO_MAIN> {
  articles_order: ArticleOrder[];
  show_schedule: boolean;
  article_selections: ItemSelectionType;
  articles: UmpireArticle[];
}

export interface ArticleOrder {
  article_id: string;
  article_index: number;
}
